export default __webpack_public_path__ + "fa52b732f33a6a8c50fa52ef3e626e45.wav";